import { useEffect } from 'react';

import { useLazyReadFeedQuery } from '../service/feed.api';
import { useAppSelector } from '../../../../../store';
import { selectShopCurrent } from '../../shops/store/shopSlice';

export const useFeed = () => {
    const current = useAppSelector(selectShopCurrent);

    const [getFeed, { data }] = useLazyReadFeedQuery();

    useEffect(() => {
        if (current.id) {
            getFeed(current.id);
        }
    }, [current.id]);

    return { data };
};
